import { render, staticRenderFns } from "./userCollectionLogin.vue?vue&type=template&id=7e45a68d&"
import script from "./userCollectionLogin.vue?vue&type=script&lang=js&"
export * from "./userCollectionLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports